import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { trackPageAction } from "actions/shared/tracking-actions";
import {
  addCardNumberToFilterAction,
  addCategoryToFilterAction,
  addCurrencyToFilterAction,
  addDocumentTypeToFilterAction,
  addEndDateToFilterAction,
  addEnvelopeToFilterAction,
  addPaymentTypeToFilterAction,
  addStartDateToFilterAction,
  addVendorToFilterAction,
  clearExportTypeFilterAction,
  orderByAction,
  removeCardNumberFromFilterAction,
  removeCategoryFromFilterAction,
  removeCurrencyFromFilterAction,
  removeDocumentTypeFromFilterAction,
  removeEnvelopeFromFilterAction,
  removePaymentTypeFromFilterAction,
  removeVendorFromFilterAction,
  setExportTypeFilterAction,
  addSearchQueryToFilterAction,
  removeSearchQueryFromFilterAction,
  updateSearchQueryAction,
  resetFiltersAction,
  addViewedStatusToFilterAction,
  removeViewedStatusFromFilterAction
} from "actions/document-filters-actions";
import {
  createCustomTabAction,
  updateCustomTabNameAction,
  startDeleteCustomTabModeAction
} from "actions/custom-tabs-actions";
import { CustomTab } from "components/documents/custom-tab";

class CustomTabPage extends React.Component {
  componentWillMount() {
    this.props.trackPage();
  }

  componentWillUnmount() {
    this.props.resetFilters();
  }

  render() {
    return <CustomTab { ...this.props } />;
  }
}

CustomTabPage.propTypes = {
  resetFilters: PropTypes.func.isRequired,
  trackPage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  accountSlug: state.app.selectedAccount.slug,
  allDocumentsTotal: state.documents.pagination.totalCount,
  cardNumbers: state.cardNumbers.cardNumbers,
  categories: state.categories.categories,
  currencies: state.currencies.currencies,
  customTabName: state.customTabs.customTabName,
  customTabs: state.customTabs.customTabs,
  endDate: state.documentFilters.endDate,
  envelopes: state.envelopes.envelopes,
  exportType: state.documentFilters.exportType,
  filters: state.documentFilters,
  isCreateCustomTabLoading: state.customTabs.isCreateCustomTabLoading,
  lastFourDigits: state.documentFilters.lastFourDigits,
  preferredCurrency: state.accountSettings.currency,
  searchQueryString: state.documentFilters.searchQueryString,
  selectedCardNumbers: state.documentFilters.selectedCardNumbers,
  selectedCategories: state.documentFilters.selectedCategories,
  selectedCurrencies: state.documentFilters.selectedCurrencies,
  selectedEnvelopes: state.documentFilters.selectedEnvelopes,
  selectedMergeDocumentId: state.documents.selectedMergeDocumentId,
  selectedPaymentTypes: state.documentFilters.selectedPaymentTypes,
  selectedDocumentIds: state.documents.selectedDocumentIds,
  selectedSearchQueryString: state.documentFilters.selectedSearchQueryString,
  selectedVendors: state.documentFilters.selectedVendors,
  startDate: state.documentFilters.startDate,
  type: state.documentFilters.type,
  vendors: state.vendors.vendors,
  viewedStatus: state.documentFilters.viewedStatus
});

const mapDispatchToProps = (dispatch) => ({
  trackPage: () => dispatch(trackPageAction("Custom tab page")),
  resetFilters: () => dispatch(resetFiltersAction()),
  onAddCardNumber: (data) => dispatch(addCardNumberToFilterAction(data.key)),
  onAddCategory: (data) => dispatch(addCategoryToFilterAction(data.name)),
  onAddCurrency: (data) => dispatch(addCurrencyToFilterAction(data.key)),
  onAddDocumentType: (data) => dispatch(addDocumentTypeToFilterAction(data.key)),
  onAddEndDate: (data) => dispatch(addEndDateToFilterAction(data)),
  onAddEnvelope: (data) => dispatch(addEnvelopeToFilterAction(data.key)),
  onAddPaymentType: (data) => dispatch(addPaymentTypeToFilterAction(data.key)),
  onAddSearchQuery: (query) => dispatch(addSearchQueryToFilterAction(query)),
  onAddStartDate: (data) => dispatch(addStartDateToFilterAction(data)),
  onAddVendor: (data) => dispatch(addVendorToFilterAction(data.name)),
  onAddViewedStatus: (data) => dispatch(addViewedStatusToFilterAction(data.key)),
  onCreateCustomTab: (accountId, filters, tabName) => dispatch(createCustomTabAction(accountId, filters, tabName)),
  onClearExportType: () => dispatch(clearExportTypeFilterAction()),
  onOrderBy: (key) => dispatch(orderByAction(key)),
  onRemoveCardNumber: (card) => dispatch(removeCardNumberFromFilterAction(card)),
  onRemoveCategory: (name) => dispatch(removeCategoryFromFilterAction(name)),
  onRemoveCurrency: (data) => dispatch(removeCurrencyFromFilterAction(data)),
  onRemoveDocumentType: () => dispatch(removeDocumentTypeFromFilterAction()),
  onRemoveEnvelope: (name) => dispatch(removeEnvelopeFromFilterAction(name)),
  onRemoveSearchQuery: () => dispatch(removeSearchQueryFromFilterAction()),
  onRemovePaymentType: (name) => dispatch(removePaymentTypeFromFilterAction(name.toLowerCase())),
  onRemoveVendor: (name) => dispatch(removeVendorFromFilterAction(name)),
  onRemoveViewedStatus: () => dispatch(removeViewedStatusFromFilterAction()),
  onStartDeleteCustomTabMode: (id) => dispatch(startDeleteCustomTabModeAction(id)),
  onUpdateCustomTabName: (name) => dispatch(updateCustomTabNameAction(name)),
  onUpdateSearchQuery: (query) => dispatch(updateSearchQueryAction(query)),
  onSetExportType: (data) => dispatch(setExportTypeFilterAction(data.key))
});

export const CustomTabContainer = connect(mapStateToProps, mapDispatchToProps)(CustomTabPage);



// WEBPACK FOOTER //
// ./src/js/containers/custom-tab-container.jsx